module.exports = __webpack_public_path__ + "image/index_pro_img2.png";